import type {ElementType} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './title.module.css';

type Props = {
  /** @default h2 */
  readonly as?: ElementType;
  readonly companyId: number;
};

export function LatestStoriesTitle({as: As = 'h2', companyId}: Props) {
  return (
    <div className={styles.header}>
      <As
        className={clsx(
          styles.title,
          isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
        )}
      >
        ストーリー
      </As>
      <a
        href={`/main/html/searchrlp/company_id/${companyId}?tab=story`}
        className={styles.seeMore}
      >
        もっと見る
      </a>
    </div>
  );
}
